"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.conjunctFormat = exports.disjunctFormat = exports.parseRedirectTextToMultimediaContent = exports.parseGreetingTextToMultimediaTexts = exports.parseTextTranslationToMultimediaText = exports.getTranslation = exports.createTextMultimediaText = exports.generateMultimediaTextFromTranslation = exports.processDraftJSTextReference = exports.createNewRichTextObject = exports.combineMultimediaTexts = exports.getCombinedMultimediaTextByLanguage = exports.getMultimediaTextByLanguage = exports.getUseWordDelimiterByLanguage = exports.getStringFromMultimediaTexts = exports.getFriendlyListFormat = exports.formatOpenEndedSummary = exports.getLastAfterSplit = exports.getTextByIndex = exports.replaceRange = exports.getOrdinalNumber = exports.hmacSHA256InHex = exports.getQueryString = exports.getQueryStringValue = exports.formatThousandSeparator = exports.formatNumber = exports.formatLanguageKey = exports.getPureStringFromHTML = exports.lowercaseFirstLetter = exports.uppercaseFirstLetter = void 0;
var _ = require("lodash");
var uuid = require("uuid");
var DraftJS = require("draft-js");
var CryptoJS = require("crypto-js");
var types_1 = require("../types");
var index_1 = require("../utils/index");
var constants_1 = require("../constants");
/** BEGIN SIMPLE STRING HANDLER */
var defaultMultimediaText = function () {
    return {
        language: constants_1.ENGLISH,
        contents: [
            {
                type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                richText: createNewRichTextObject('')
            }
        ]
    };
};
/**
 * Capitalize the first letter of `word`
 */
function uppercaseFirstLetter(word) {
    if (word.length === 0)
        return '';
    return word.charAt(0).toUpperCase() + word.slice(1);
}
exports.uppercaseFirstLetter = uppercaseFirstLetter;
function lowercaseFirstLetter(word) {
    if (word.length === 0)
        return '';
    return word.charAt(0).toLowerCase() + word.slice(1);
}
exports.lowercaseFirstLetter = lowercaseFirstLetter;
function getPureStringFromHTML(word) {
    try {
        if (word === null || word === '') {
            return '';
        }
        return word.replace(/(<([^>]+)>)/gi, '');
    }
    catch (err) {
        return word;
    }
}
exports.getPureStringFromHTML = getPureStringFromHTML;
function formatLanguageKey(rawLanguageKey) {
    console.log('rawLanguageKey', rawLanguageKey);
    //Chinese language codes i.e. zh_TW
    if (rawLanguageKey.includes('_')) {
        var chunks = rawLanguageKey.split('_');
        return chunks[0].toLowerCase() + '_' + chunks[1].toUpperCase();
    }
    return rawLanguageKey.toLowerCase();
}
exports.formatLanguageKey = formatLanguageKey;
/**
 * This function formats number with various options
 * - thousandSeparator - add comma every 3 digits
 * - allowDecimals - allow decimal points and it always comes with numDecimals
 * - numDecimals - Forcibly set the number of decimal points
 * @returns string - formatted number
 */
var formatNumber = function (value, settings) {
    if (value === void 0) { value = 0; }
    if (settings === void 0) { settings = {}; }
    var formattedPlaceholder = value;
    try {
        formattedPlaceholder = Number(value);
        formattedPlaceholder = formattedPlaceholder.toLocaleString('en-US', {
            minimumFractionDigits: settings.allowDecimal && settings.numDecimals
                ? settings.numDecimals
                : 0,
            maximumFractionDigits: settings.allowDecimal && settings.numDecimals
                ? settings.numDecimals
                : 0
        });
        if (!(settings === null || settings === void 0 ? void 0 : settings.thousandSeparator)) {
            formattedPlaceholder = _.replace(formattedPlaceholder, /,/g, '');
        }
    }
    catch (err) { }
    return formattedPlaceholder;
};
exports.formatNumber = formatNumber;
/**
 * @returns a numeric value with comma in every 3 digits i.e. 1000 -> 1,000
 */
var formatThousandSeparator = function (value, thousandSeparator) {
    if (value === void 0) { value = 0; }
    if (thousandSeparator === void 0) { thousandSeparator = false; }
    var formattedValue = value;
    try {
        if (thousandSeparator) {
            return formattedValue.toLocaleString('en-US', {
                minimumFractionDigits: 0
            });
        }
    }
    catch (err) {
        formattedValue = value;
    }
    return String(formattedValue);
};
exports.formatThousandSeparator = formatThousandSeparator;
/*
 * URL Query parsing funcs and misc helpers
 */
/**
 * This is used to extract trackerID (MID), source etc. from URL.
 * Note: this function is case insensitive, and will return an empty string
 * if there is no match.
 * @TODO: typing
 */
function getQueryStringValue(key) {
    return (decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' +
        encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') +
        '(?:\\=([^&]*))?)?.*$', 'i'), '$1')) || null);
}
exports.getQueryStringValue = getQueryStringValue;
/**
 * Get Query parameters using keyName
 * @param name
 */
function getQueryString(name) {
    var useQuery = new URLSearchParams(location.search);
    return useQuery.get(name);
}
exports.getQueryString = getQueryString;
function hmacSHA256InHex(key, value) {
    return CryptoJS.HmacSHA256(value, key).toString(CryptoJS.enc.Hex);
}
exports.hmacSHA256InHex = hmacSHA256InHex;
/**
 * get ordinal number by number
 * i.e. 2 -> '2nd'
 * @returns string
 */
function getOrdinalNumber(n) {
    var ord = 'th';
    if (n % 10 == 1 && n % 100 != 11) {
        ord = 'st';
    }
    else if (n % 10 == 2 && n % 100 != 12) {
        ord = 'nd';
    }
    else if (n % 10 == 3 && n % 100 != 13) {
        ord = 'rd';
    }
    return n + ord;
}
exports.getOrdinalNumber = getOrdinalNumber;
/*
 * String manipulation / parsing functions.
 * Parse string to char array to handle emoji properly. Emoji takes 2 space in javascript string
 * Returns string type after replacement
 *
 */
function replaceRange(string, startIndex, endIndex, substitute) {
    var array = _.toArray(string);
    array = __spreadArray(__spreadArray(__spreadArray([], array.slice(0, startIndex), true), [
        substitute
    ], false), array.slice(endIndex), true);
    return array.join('');
}
exports.replaceRange = replaceRange;
/**
 * Doing exact same thing with Javascript slice function but wrap with `toArray` function to handle emoji properly
 * i.e. if you use .slice(), each emoji sometimes takes more than one character so the index based slice gets messed up
 */
function getTextByIndex(text, startIndex, endIndex) {
    return _.slice(_.toArray(text), startIndex, endIndex).join('');
}
exports.getTextByIndex = getTextByIndex;
/**
 *  return last index of an string after split by key
 * */
function getLastAfterSplit(languageResponse, splitKey) {
    return typeof languageResponse === 'string'
        ? (0, index_1.last)(languageResponse.split(splitKey))
        : (0, index_1.last)(languageResponse.value.split(splitKey));
}
exports.getLastAfterSplit = getLastAfterSplit;
function formatOpenEndedSummary(summary) {
    var isBulletItem = false;
    return summary === null || summary === void 0 ? void 0 : summary.split('\n').reduce(function (arr, text) {
        var isBulletPoint = (text === null || text === void 0 ? void 0 : text[0]) === '-';
        if (isBulletPoint) {
            var formattedText = text.slice(1).trim(); // remove "-" and space at the beginning of text
            if (isBulletItem) {
                (0, index_1.last)(arr).items.push(formattedText);
            }
            else {
                arr.push({ type: 'list', items: [formattedText] });
                isBulletItem = true;
            }
            return arr;
        }
        isBulletItem = false;
        return __spreadArray(__spreadArray([], arr, true), [{ type: 'p', text: text }], false);
    }, []);
}
exports.formatOpenEndedSummary = formatOpenEndedSummary;
/*
 * Helper function for friendly text formatting, which converts
 * a list of strings into a single string. The return format varies
 * depending on the number of strings in the input:
 *   - 1 string: "string1"
 *   - 2 strings: "string1 and string2"
 *   - >2 strings: "string1, string2, ... stringN-1, and stringN"
 */
function getFriendlyListFormat(strings, i18n) {
    if (!strings.length)
        return '';
    else if (strings.length === 1)
        return strings[0];
    else if (strings.length === 2)
        return "".concat(strings[0], " and ").concat(strings[1]);
    else {
        var subList = strings.slice(0, strings.length - 1);
        var subListString = subList.join(', ');
        var lastString = strings[strings.length - 1];
        var conjunction = getTranslation(i18n === null || i18n === void 0 ? void 0 : i18n.t, 'LABEL.AND', {}, 'and');
        return "".concat(subListString, " ").concat(conjunction, " ").concat(lastString);
    }
}
exports.getFriendlyListFormat = getFriendlyListFormat;
/** END SIMPLE STRING HANDLER */
/** BEGIN RICH TEXT HANDLER */
/*
 * Returns a string from a MultimediaText[] corresponding to the specified
 * langId. If langId is null, then the default text is returned.
 */
function getStringFromMultimediaTexts(multimediaTexts, langId, defaultText) {
    if (defaultText === void 0) { defaultText = ''; }
    try {
        var text_1 = '';
        var multimediaText = multimediaTexts === null || multimediaTexts === void 0 ? void 0 : multimediaTexts.find(function (t) { return t.language == langId; });
        multimediaText === null || multimediaText === void 0 ? void 0 : multimediaText.contents.forEach(function (content) {
            switch (content.type) {
                case types_1.MULTIMEDIA_TYPES.TEXT:
                    text_1 += content.text;
                    break;
            }
        });
        return text_1 || defaultText;
    }
    catch (e) {
        return defaultText;
    }
}
exports.getStringFromMultimediaTexts = getStringFromMultimediaTexts;
function getUseWordDelimiterByLanguage(texts, langId) {
    var _a, _b;
    var textTranslation = texts.find(function (t) { return t.language == langId; });
    var textOptions = (_b = (_a = textTranslation === null || textTranslation === void 0 ? void 0 : textTranslation.contents) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.textOptions;
    return textOptions && 'useWordDelimiter' in textOptions
        ? Boolean(textOptions.useWordDelimiter)
        : true;
}
exports.getUseWordDelimiterByLanguage = getUseWordDelimiterByLanguage;
function getMultimediaTextByLanguage(multimediaTexts, langId, fallbackLng) {
    if (fallbackLng === void 0) { fallbackLng = constants_1.ENGLISH; }
    try {
        var traslatedMultimediaText = multimediaTexts.find(function (t) { return t.language == langId; });
        var multimediaTextClone = _.cloneDeep(traslatedMultimediaText);
        var convertPlainTextToRich_1 = function (plainTextObject) {
            return {
                id: 'TEMP_TODO',
                richText: {
                    blocks: [
                        {
                            key: 'TEMP_TODO',
                            text: plainTextObject === null || plainTextObject === void 0 ? void 0 : plainTextObject.text,
                            type: 'unstyled',
                            depth: 0,
                            inlineStyleRanges: [],
                            entityRanges: [],
                            data: {}
                        }
                    ],
                    entityMap: {}
                },
                type: types_1.MULTIMEDIA_TYPES.RICH_TEXT
            };
        };
        if (multimediaTextClone) {
            var richTextContents = multimediaTextClone.contents.map(function (content) {
                if (content.type === types_1.MULTIMEDIA_TYPES.RICH_TEXT ||
                    content.type === types_1.MULTIMEDIA_TYPES.IMAGE) {
                    return content;
                }
                else if (content.type === 'plainText') {
                    return convertPlainTextToRich_1(content);
                }
            });
            multimediaTextClone.contents = richTextContents;
            return multimediaTextClone;
        }
        throw new Error("Language ".concat(langId, " in ").concat(multimediaTexts, " not found"));
    }
    catch (e) {
        var fallbackMultimediaText = multimediaTexts === null || multimediaTexts === void 0 ? void 0 : multimediaTexts.find(function (t) { return t.language === fallbackLng; });
        if (fallbackLng && fallbackMultimediaText) {
            return fallbackMultimediaText;
        }
        return defaultMultimediaText();
    }
}
exports.getMultimediaTextByLanguage = getMultimediaTextByLanguage;
function getCombinedMultimediaTextByLanguage(texts, langId, separator) {
    var _a;
    if (separator === void 0) { separator = '\n'; }
    try {
        var multimediaText = texts.find(function (t) { return t.language == langId; });
        var hasQuestionTexts = (_a = multimediaText === null || multimediaText === void 0 ? void 0 : multimediaText.contents) === null || _a === void 0 ? void 0 : _a.length;
        var stringText_1 = '';
        if (!hasQuestionTexts)
            return stringText_1;
        multimediaText === null || multimediaText === void 0 ? void 0 : multimediaText.contents.forEach(function (content) {
            var text = '';
            switch (content.type) {
                case types_1.MULTIMEDIA_TYPES.RICH_TEXT:
                    var richTextContent = content;
                    richTextContent.richText.blocks.forEach(function (block) {
                        var blockText = block.text;
                        if (block.entityRanges.length) {
                            block.entityRanges.forEach(function (richTextEntityRange) {
                                var dynamicReference = blockText.substring(richTextEntityRange.offset, richTextEntityRange.offset +
                                    richTextEntityRange.length);
                                blockText = blockText.replace(dynamicReference, "".concat(constants_1.DYNAMIC_TEXT_REFERENCE_TAG).concat(dynamicReference).concat(constants_1.DYNAMIC_TEXT_REFERENCE_TAG));
                            });
                        }
                        text += "".concat(blockText, " ");
                    });
                    break;
                case types_1.MULTIMEDIA_TYPES.AUDIO:
                case types_1.MULTIMEDIA_TYPES.IMAGE:
                case types_1.MULTIMEDIA_TYPES.VIDEO:
                    text = "[".concat(content.type, "] ").concat(content.mediaURL);
                    break;
                case types_1.MULTIMEDIA_TYPES.TEXT:
                    text = content.text;
                    break;
            }
            stringText_1 = stringText_1.trim().length
                ? "".concat(stringText_1, " ").concat(separator, " ").concat(text)
                : text;
        });
        return stringText_1;
    }
    catch (e) {
        console.error(e);
        return '';
    }
}
exports.getCombinedMultimediaTextByLanguage = getCombinedMultimediaTextByLanguage;
function combineMultimediaTexts(baseMultimediaTexts, sMultimediaTexts) {
    try {
        var newMultimediaText = baseMultimediaTexts.map(function (multimediaText) {
            var langId = multimediaText.language;
            var secondMultimediaTextByLanguage = sMultimediaTexts.find(function (s) { return s.language == langId; });
            return __assign(__assign({}, multimediaText), { contents: ((multimediaText === null || multimediaText === void 0 ? void 0 : multimediaText.contents) || []).concat((secondMultimediaTextByLanguage === null || secondMultimediaTextByLanguage === void 0 ? void 0 : secondMultimediaTextByLanguage.contents) || []) });
        });
        return newMultimediaText;
    }
    catch (err) {
        return baseMultimediaTexts;
    }
}
exports.combineMultimediaTexts = combineMultimediaTexts;
function createNewRichTextObject(defaultText) {
    if (defaultText === void 0) { defaultText = ''; }
    return DraftJS.convertToRaw(DraftJS.ContentState.createFromText(defaultText));
}
exports.createNewRichTextObject = createNewRichTextObject;
/*
 * This function accepts several objects from a DraftJS block as well as
 *  a function to get new wordings based on
 *  1) portal - during group duplication, the reference question id/wordings need to be remaaped/rearranged
 *  2) bot - during the process of the question, dynamic text reference block is replaced
 *       by the corresponding answer from the question specified by the entity (in the entityMap array).
 *
 * TODO: Only replace entities of a certain type ()"dynamic text")
 * TODO: DraftJS Typing
 * TODO: case/switch on DraftJS entity type (MESSAGE_BREAK, etc.)
 */
function processDraftJSTextReference(text, entityRanges, inlineStyleRanges, question, entityMap, getWording) {
    var newText = text;
    var newEntityRanges = entityRanges;
    var newStyleRanges = inlineStyleRanges;
    // for each entity applied, replace it with the answer from the ref'd question
    // runningOffset helps us to track the offset resulting from the number of characters
    // changing as a consequence of replacing entity placeholders with the dynamic text (user answers)
    var runningOffset = 0;
    entityRanges.map(function (range, index) {
        var offset = range.offset, length = range.length, key = range.key;
        var entity = entityMap[key];
        // for entities aside from dynamic text referencing, simply increase
        // the offset accordingly and then skip!
        if (!['DYNAMIC_TEXT_REFERENCE', 'ROOT_REFERENCE'].includes(entity.type)) {
            newEntityRanges[index] = __assign(__assign({}, newEntityRanges[index]), { offset: newEntityRanges[index].offset + runningOffset });
            return;
        }
        var friendlyAnswer = getWording(key);
        try {
            // insert friendlyAnswer into text block
            newText = replaceRange(newText, offset + runningOffset, offset + runningOffset + length, friendlyAnswer);
            // update offset and length for this entity range
            newEntityRanges[index] = __assign(__assign({}, newEntityRanges[index]), { offset: newEntityRanges[index].offset + runningOffset, length: friendlyAnswer.length });
            // get currentOffset (discrepancy between entity length and answer Length)
            var currentOffset_1 = friendlyAnswer.length - length;
            var curEntityRange_1 = newEntityRanges[index];
            // update inline styles as needed
            newStyleRanges = newStyleRanges.map(function (styleRange) {
                switch (true) {
                    // case 1: styleRange overlaps with entityRange
                    // case 2: text reference with styling
                    case styleRange.offset <= curEntityRange_1.offset &&
                        styleRange.offset + styleRange.length >=
                            curEntityRange_1.offset +
                                curEntityRange_1.length -
                                currentOffset_1:
                        return __assign(__assign({}, styleRange), { length: styleRange.length + currentOffset_1 });
                    // case 3: styleRange comes after entityRange
                    case curEntityRange_1.offset < styleRange.offset:
                        return __assign(__assign({}, styleRange), { offset: styleRange.offset + currentOffset_1 });
                    default:
                        return styleRange;
                }
            });
            runningOffset += currentOffset_1;
        }
        catch (e) {
            console.warn({
                message: "dynamic text referencing failed for ref question",
                data: { questionId: question.id }
            });
        }
    });
    return { newText: newText, newEntityRanges: newEntityRanges, newStyleRanges: newStyleRanges };
}
exports.processDraftJSTextReference = processDraftJSTextReference;
/**
 * @TODO: document -- how is this different than createTextMultimediaText?
 * @TODO: typing
 */
function generateMultimediaTextFromTranslation(languages, t, translateKey, translationOptions) {
    return languages.map(function (l) {
        var object = JSON.parse(getTranslation(t, translateKey, __assign({ lng: l.value }, translationOptions)));
        var questionWordings = object.question;
        questionWordings = questionWordings.split('\n');
        return {
            language: l.value,
            contents: questionWordings.map(function (wordings) { return ({
                type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                richText: createNewRichTextObject(wordings)
            }); })
        };
    });
}
exports.generateMultimediaTextFromTranslation = generateMultimediaTextFromTranslation;
/** END RICH TEXT HANDLER */
/**
 * Creates a MultimediaText[] object for a specified @translationKey using the @t translation function
 * and including each of the translations corresponding to the provided @languages
 * If a translation is not available for a particular language, fallback to @fallbackString
 * @TODO: typing
 */
function createTextMultimediaText(t, languages, translationKey, fallbackString) {
    return languages.map(function (language) {
        var text = getTranslation(t, translationKey, { lng: language.value }, fallbackString);
        return {
            language: language.value,
            contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: text }]
        };
    });
}
exports.createTextMultimediaText = createTextMultimediaText;
function getTranslation(t, translationKey, options, fallbackString) {
    if (options === void 0) { options = {}; }
    if (fallbackString === void 0) { fallbackString = ''; }
    try {
        var translation = '';
        if (t && translationKey) {
            translation = t(translationKey, __assign({}, options));
            // trnalsation failed
            if (translationKey == translation) {
                translation = fallbackString || translationKey;
            }
        }
        if (!translation && fallbackString) {
            translation = fallbackString;
        }
        return translation;
    }
    catch (err) {
        return fallbackString;
    }
}
exports.getTranslation = getTranslation;
/** END i18n */
/** @BACKWARD_COMPATIBILITY */
function parseTextTranslationToMultimediaText(questionTexts) {
    try {
        var newQuestionTexts = questionTexts;
        if ((questionTexts === null || questionTexts === void 0 ? void 0 : questionTexts.length) && _.hasIn(questionTexts[0], 'richTexts')) {
            newQuestionTexts = questionTexts.map(function (qt) {
                var contents = qt.richTexts.map(function (richText) { return ({
                    id: uuid.v4(),
                    type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                    richText: richText
                }); });
                return {
                    language: qt.language,
                    contents: contents
                };
            });
        }
        else if ((questionTexts === null || questionTexts === void 0 ? void 0 : questionTexts.length) && _.hasIn(questionTexts[0], 'text')) {
            newQuestionTexts = questionTexts.map(function (qt) {
                var contents = [
                    {
                        id: uuid.v4(),
                        type: types_1.MULTIMEDIA_TYPES.TEXT,
                        text: qt.text
                    }
                ];
                return {
                    language: qt.language,
                    contents: contents
                };
            });
        }
        return newQuestionTexts;
    }
    catch (err) {
        return questionTexts;
    }
}
exports.parseTextTranslationToMultimediaText = parseTextTranslationToMultimediaText;
/**
 * @param greetingText may be a MultimediaTexts[] or any legacy text format (?).
 * @param firstLanguage may be any language code, English by default, which determines the marked language of returned text.
 * @returns a valid MultimediaText[] object which can be used by chatbot as greeting message.
 * @TODO: improve typing and specify for the different cases what kind of object greetingText is.
 */
function parseGreetingTextToMultimediaTexts(greetingText, firstLanguage) {
    if (firstLanguage === void 0) { firstLanguage = 'en'; }
    try {
        var newGreetingText = greetingText;
        if (_.isArray(newGreetingText) && 'language' in (newGreetingText === null || newGreetingText === void 0 ? void 0 : newGreetingText[0])) {
            return newGreetingText;
        }
        else if (_.isArray(newGreetingText) &&
            'richText' in (newGreetingText === null || newGreetingText === void 0 ? void 0 : newGreetingText[0])) {
            newGreetingText = [
                {
                    language: firstLanguage,
                    contents: newGreetingText
                }
            ];
        }
        else if (_.isArray(greetingText) &&
            (greetingText === null || greetingText === void 0 ? void 0 : greetingText.length) &&
            _.hasIn(greetingText[0], 'blocks')) {
            newGreetingText = [
                {
                    language: firstLanguage,
                    contents: greetingText.map(function (richText) { return ({
                        id: uuid.v4(),
                        type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                        richText: richText
                    }); })
                }
            ];
        }
        return newGreetingText;
    }
    catch (err) {
        return greetingText;
    }
}
exports.parseGreetingTextToMultimediaTexts = parseGreetingTextToMultimediaTexts;
function parseRedirectTextToMultimediaContent(redirectSettings) {
    try {
        var newRedirectSettings = redirectSettings;
        if (_.hasIn(redirectSettings.redirects[0], 'texts')) {
            newRedirectSettings.redirects = newRedirectSettings.redirects.map(function (redirect) {
                var multimediaTexts = redirect.texts.map(function (text) {
                    var contents = text.richTexts.map(function (richText) { return ({
                        id: uuid.v4(),
                        type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                        richText: richText
                    }); });
                    return { language: text.language, contents: contents };
                });
                return {
                    type: redirect.type,
                    url: redirect.url,
                    multimediaTexts: multimediaTexts
                };
            });
        }
        return newRedirectSettings;
    }
    catch (err) {
        return redirectSettings;
    }
}
exports.parseRedirectTextToMultimediaContent = parseRedirectTextToMultimediaContent;
/**
 * Formats @list as a disjunctive list.
 * For example, ['John', 'Bob'] -> 'John, or Bob'
 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat
 */
var disjunctFormat = function (list) {
    // @ts-ignore -- ListFormat only added in es2021
    var formatter = new Intl.ListFormat('en-US', {
        style: 'long',
        type: 'disjunction'
    });
    return formatter.format(list);
};
exports.disjunctFormat = disjunctFormat;
/**
 * Formats @list as a conjunctive list.
 * For example, ['John', 'Bob', 'Bill'] -> 'John, Bob, and Bill'
 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat
 */
var conjunctFormat = function (list) {
    // @ts-ignore -- ListFormat only added in es2021
    var formatter = new Intl.ListFormat('en-US', {
        style: 'long',
        type: 'conjunction'
    });
    return formatter.format(list);
};
exports.conjunctFormat = conjunctFormat;
//# sourceMappingURL=TextService.js.map